import { render, staticRenderFns } from "./RoleEditorView.vue?vue&type=template&id=7e5a368e&scoped=true&"
import script from "./RoleEditorView.vue?vue&type=script&lang=js&"
export * from "./RoleEditorView.vue?vue&type=script&lang=js&"
import style0 from "./RoleEditorView.vue?vue&type=style&index=0&id=7e5a368e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5a368e",
  null
  
)

export default component.exports